var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("singleselect", {
            attrs: {
              checked: _vm.shiftModel.material,
              name: "materials",
              options: _vm.materials,
              "allow-empty": false
            },
            model: {
              value: _vm.material,
              callback: function($$v) {
                _vm.material = $$v
              },
              expression: "material"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("span", [_vm._v(_vm._s(_vm.materialUnit))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.quantity,
              expression: "quantity"
            }
          ],
          staticClass: "form-control",
          staticStyle: { width: "100px" },
          attrs: {
            disabled: !_vm.material,
            step: _vm.step,
            min: "0",
            type: "number"
          },
          domProps: { value: _vm.quantity },
          on: {
            keyup: _vm.updateQuantity,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.quantity = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-1" },
        [
          _c("singleselect", {
            attrs: {
              checked: _vm.shiftModel.warehouseFrom,
              name: "warehouse-from",
              options: _vm.warehousesFrom,
              "allow-empty": false
            },
            model: {
              value: _vm.warehouseFrom,
              callback: function($$v) {
                _vm.warehouseFrom = $$v
              },
              expression: "warehouseFrom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("singleselect", {
            attrs: {
              checked: _vm.shiftModel.warehouseTo,
              name: "warehouse-to",
              options: _vm.warehousesTo,
              "allow-empty": false,
              placeholder: "Wybierz magazyn"
            },
            model: {
              value: _vm.warehouseTo,
              callback: function($$v) {
                _vm.warehouseTo = $$v
              },
              expression: "warehouseTo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-2" },
        [
          _c("singleselect", {
            attrs: {
              name: "meal",
              checked: _vm.shiftModel.meal,
              options: _vm.meals,
              "allow-empty": false
            },
            model: {
              value: _vm.meal,
              callback: function($$v) {
                _vm.meal = $$v
              },
              expression: "meal"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.description,
              expression: "description"
            }
          ],
          staticClass: "form-control",
          staticStyle: { width: "100px" },
          attrs: { type: "text" },
          domProps: { value: _vm.description },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.description = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-1" },
        [
          _c("date-picker", {
            attrs: { "input-class": "form-control", config: _vm.dateOptions },
            model: {
              value: _vm.expectedDate,
              callback: function($$v) {
                _vm.expectedDate = $$v
              },
              expression: "expectedDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c(
          "div",
          {
            staticClass: "btn btn-danger btn-block",
            on: { click: _vm.deleteRow }
          },
          [_c("b", [_vm._v("Usuń")])]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.hasErrors
      ? _c("div", { staticClass: "row", staticStyle: { color: "red" } }, [
          _c("div", { staticClass: "col-md-2" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("material")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("unit")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("amountExpected")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("warehouseFrom")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("warehouseTo")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("meal")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("description")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }, [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(_vm._s(_vm.getError("dateExpected")))
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.hasClassErrors
      ? _c(
          "div",
          { staticClass: "row", staticStyle: { color: "red" } },
          _vm._l(_vm.classErrors, function(error, index) {
            return _c("div", { key: index, staticClass: "col-md-12" }, [
              _c("p", { staticClass: "form-control-static" }, [
                _vm._v(_vm._s(error))
              ])
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-2" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Pozycja")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Jednostka")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Ilość")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Z magazynu")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Na magazyn")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Dla wyprod.")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Uwagi")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [
        _c("p", { staticClass: "form-control-static" }, [_vm._v("Godzina")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9edff2c6", { render: render, staticRenderFns: staticRenderFns })
  }
}